import * as React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const variants = {
  open: {
    y: 0,
    opacity: 1,
    transition: {
      y: { stiffness: 1000, velocity: -100 },
    },
  },
  closed: {
    y: 50,
    opacity: 0,
    transition: {
      y: { stiffness: 1000 },
    },
  },
};

const colors = ["#FF008C", "#D309E1", "#4400FF"];
const links = [
  { name: "HOME", link: "/", icon: "fab fa-blogger-b" },
  { name: "BLOGS", link: "/blogs", icon: "fas fa-user-circle" },
];

export const MenuItem = ({ i, j }) => {
  const style = {
    border: `3px solid ${colors[i]}`,
    textAlign: "center",
    color: `${colors[i]}`,
    fontFamily: "Poppins",
  };
  const routes = links[j];
  return (
    <motion.li
      variants={variants}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.95 }}
    >
      <div className="icon-placeholder" style={style}>
        <i className={routes.icon} style={{ verticalAlign: "center" }} />
      </div>
      <Link className="text-placeholder" style={style} to={`${routes.link}`}>
        {routes.name}
      </Link>
    </motion.li>
  );
};
